module.exports = __webpack_public_path__ + "static/img/G5_V2.a368758.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/captation/img/G5_V2.png
// module id = iI7h
// module chunks = 1